class CommissionsSummaryCtrl {

    static calculateTotal(list, property) {
        if (list && list.length !== 0) {
            const total = list.reduce((a, b) => a + b[property].amount, 0);
            return {...list[0][property], amount: total};
        }
        return null;
    }

    constructor($q, ModalService, $scope, $filter, AccountService, $stateParams, $state) {
        this.$state = $state;

        this.isNegative = (value) => value.amount < 0;
        this.isZero = (value) => value.amount === 0;

        this.$onInit = () => {
            this.commissionsLoading = true;
            this.transactionsLoading = true;
            this.errorRetrieveData = false;
            this.commissions = [];
            this.filteredTransactions = [];

            const accountNumber = this.account.accountNumber || $stateParams.accountNumber;
            const getPoliciesInForceByAccount = () => AccountService.getPoliciesInForceByAccount(accountNumber);
            const getCommissionsTransactionsByAccount = () => AccountService.getCommissionsTransactionsByAccount(accountNumber);
            const accountExists = () => AccountService.accountExists(accountNumber);

            const error = () => {
                if (!this.errorRetrieveData) {
                    this.errorRetrieveData = true;
                    ModalService.showError('gateway.views.modal.Error', 'gateway.directives.CommissionsSummaryDirective.Failed to retrieve the data');
                }
            };

            const addChartData = (commissions) => {
                commissions.forEach(commission => {
                    commission.paidNotPaid = [
                        {value: commission.paid.amount, hint: $filter('gwCurrency')(commission.paid)},
                        {value: commission.notPaid.amount, hint: $filter('gwCurrency')(commission.notPaid)}
                    ];
                });
                return commissions;
            };

            const loadCommissions = () => {
                getPoliciesInForceByAccount().then((commissions) => {
                    this.commissions = addChartData(commissions);
                    this.totalCommissions = CommissionsSummaryCtrl.calculateTotal(commissions, 'totalCommission');
                    this.commissionsLoading = false;
                }, error);

                getCommissionsTransactionsByAccount().then((transactions) => {
                    this.transactions = transactions;
                    this.filteredTransactions = this.getFilteredTransactions();
                    this.totalTransactions = CommissionsSummaryCtrl.calculateTotal(transactions, 'amount');
                    this.transactionsLoading = false;
                }, error);
            };

            accountExists().then((exist) => {
                if (exist) {
                    loadCommissions();
                } else {
                    this.commissionsLoading = false;
                    this.transactionsLoading = false;
                }
            }, error);
        };
    }

    getFilteredTransactions(selectedPolicy) {
        if (selectedPolicy) {
            return this.transactions.filter((transaction) => transaction.policy === selectedPolicy);
        }
        return this.transactions;
    }

    goToPolicyCommissions(policyNumber, termNumber) {
        this.$state.go('policies.detail.commissions', {policyNumber, termNumber});
    }

    onChange(selectedPolicy) {
        this.filteredTransactions = this.getFilteredTransactions(selectedPolicy);
        this.totalTransactions = CommissionsSummaryCtrl.calculateTotal(this.filteredTransactions, 'amount');
    }

    payInFull(nextFn, form) {
        if (form.invalid) {
            return nextFn();
        }
        this.bind().then(() => this.flowModel.next(this.model));
    }

}

CommissionsSummaryCtrl.$inject = ['$q', 'ModalService', '$scope', '$filter', 'AccountService', '$stateParams', '$state'];

export default CommissionsSummaryCtrl;
